import axios from "./axiosInstance";

const YoutubeUrlAPI = {
  getYoutubeUrl: () => axios.get(`/youtubeurls`),
};

export default YoutubeUrlAPI;